import { css } from '@emotion/react';
import { observer } from 'mobx-react-lite';
import { ReactElement, ReactNode } from 'react';

import { styled } from '../../styled';
import type { Theme } from '../../theme/interface/detailed';
import { isMobile } from '../../utils/isMobile';

type Interface = { className: string; children: ReactNode };

const style = css`
	position: fixed;
	z-index: 99999;

	& input,
	& textarea {
		font-family: inherit;
	}

	& * {
		box-sizing: content-box;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}

	${isMobile && 'div& * {cursor: initial;}'}

	& svg {
		display: block;
	}
`;

const Component = ({ className, children }: Interface): ReactElement => {
	return <div className={className}>{children}</div>;
};

export const AppContainer = styled(observer(Component))(
	({ theme }: { theme: Theme }) => ({
		right: theme.allSettings.containers.appContainer.right,
		bottom: theme.allSettings.containers.appContainer.bottom,
		fontFamily: theme.allSettings.containers.mainFonts.fontFamily,
	}),
	style
);
